import type { ReactNode } from "react";
import clsx from "clsx";
import { Text } from "@medoma/components/Text/Text";
import styles from "./SortableColumnHeader.module.scss";
import type { SortState } from "./useSortState";

type SortableColumnHeaderProps<TColumn extends string> = {
  columnId: TColumn;
  sortState: SortState<TColumn>;
  toggleSort: (column: TColumn) => void;
  children: ReactNode;
};

export function SortableColumnHeader<TColumn extends string>({
  columnId,
  sortState,
  toggleSort,
  children,
}: SortableColumnHeaderProps<TColumn>) {
  const isActive = columnId === sortState.column;
  return (
    <button
      type="button"
      className={clsx(styles.sortButton, isActive && styles.sortButtonActive)}
      onClick={() => toggleSort(columnId)}
    >
      <Text element="span" weight="medium" size="small">
        {children}
      </Text>
      <span aria-hidden="true" className={styles.sortIndicator}>
        {isActive ? (sortState.direction === "asc" ? " ▲" : " ▼") : ""}
      </span>
    </button>
  );
}
